import React, { useEffect, useRef } from "react";
import { useSquarespaceContent } from "../hooks/useSquarespaceContent";

const ServicesSection = () => {
  const { content, loading } = useSquarespaceContent();
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("animate-in");
            
            // Stagger animation for service cards
            const cards = entry.target.querySelectorAll(".service-card");
            cards.forEach((card, index) => {
              setTimeout(() => {
                card.classList.add("animate-in");
              }, index * 200);
            });
          } else {
            entry.target.classList.remove("animate-in");
            const cards = entry.target.querySelectorAll(".service-card");
            cards.forEach((card) => card.classList.remove("animate-in"));
          }
        });
      },
      { threshold: 0.2 }
    );

    if (sectionRef.current) {
      observer.observe(sectionRef.current);
    }

    return () => {
      if (sectionRef.current) {
        observer.unobserve(sectionRef.current);
      }
    };
  }, []);

  // Show loading state if content is not loaded
  if (loading || !content || !content.services) {
    return (
      <section id="services" className="services-section section" ref={sectionRef}>
        <div className="services-overlay" />
        <div className="container">
          <div className="section-header animate-element">
            <h2 className="section-title">Services</h2>
            <hr className="section-divider" />
          </div>
          <div className="services-grid">
            <p>Loading services...</p>
          </div>
        </div>
      </section>
    );
  }

  return (
    <section 
      id="services" 
      className="services-section section" 
      ref={sectionRef}
      style={{
        backgroundImage: `url(${content.services.backgroundImage})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundAttachment: 'fixed'
      }}
    >
      <div className="services-overlay" />
      <div className="container">
        <div className="section-header animate-element">
          <h2 className="section-title">{content.services.title}</h2>
          <hr className="section-divider" />
        </div>
        
        <div className="services-grid">
          {content.services.services.map((service, index) => (
            <div key={index} className="service-card animate-element">
              <div className="service-icon">
                <img 
                  src={service.icon} 
                  alt={service.iconAlt}
                  width="48" 
                  height="48"
                />
              </div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;